var b = Object.defineProperty;
var u = (n, i, e) => i in n ? b(n, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[i] = e;
var r = (n, i, e) => (u(n, typeof i != "symbol" ? i + "" : i, e), e);
const a = class a {
  constructor(i, e) {
    r(this, "pageOrigin");
    r(this, "orderId");
    r(this, "options");
    r(this, "iframe");
    r(this, "callbacks", {
      payment_complete: void 0,
      "3ds_redirect": void 0,
      submit_available_changed: void 0,
      cardholder_required_changed: void 0,
      payment_begin: void 0,
      form_layout_changed: void 0
    });
    this.orderId = i, this.options = e, this.pageOrigin = e.devMode ? a.devPageOrigin : a.pageOrigin, this.onMessage = this.onMessage.bind(this);
  }
  /**
   * @param target, either an element or a CSS selector for an element, which will be replaced with the payment
   * form
   */
  render(i) {
    if (this.iframe)
      throw new Error("RENDER_ALREADY_EXECUTED");
    const e = typeof i == "string" ? document.querySelector(i) : i;
    if (!e)
      throw new Error("TARGET_NOT_FOUND");
    const t = new URL(this.pageOrigin);
    t.pathname = a.pagePathname, t.search = a._getIframeSourceSearchParameters(this.orderId, this.options).toString(), this.iframe = a._getConfiguredIframe(t, this.options), e == null || e.appendChild(this.iframe), window.addEventListener("message", this.onMessage);
  }
  disconnect() {
    var i;
    if (!this.iframe)
      throw new Error("IFRAME_NOT_INITIALIZED");
    window.removeEventListener("message", this.onMessage), (i = this.iframe) == null || i.remove();
  }
  move(i) {
    if (!this.iframe)
      throw new Error("IFRAME_NOT_INITIALIZED");
    i.appendChild(this.iframe);
  }
  resize(i, e) {
    if (!this.iframe)
      throw new Error("IFRAME_NOT_INITIALIZED");
    i && (this.iframe.width = i), e && (this.iframe.height = e);
  }
  on(i, e) {
    this.callbacks[i] = e;
  }
  triggerPayment() {
    var i, e;
    (e = (i = this.iframe) == null ? void 0 : i.contentWindow) == null || e.postMessage({ type: "begin_payment" }, this.pageOrigin);
  }
  static _getIframeSourceSearchParameters(i, e) {
    for (const [d, s] of Object.entries(e))
      typeof s == "object" ? JSON.stringify(s) : s.toString();
    const t = new URLSearchParams();
    t.append("order_id", i), t.append("theme", e.theme || "light");
    const o = e.lang === "ka" ? "ka" : "en";
    return t.append("lang", o), t.append("options", JSON.stringify(e)), t;
  }
  static _getConfiguredIframe(i, e) {
    const t = document.createElement("iframe");
    return t.src = i.toString(), t.setAttribute("sandbox", "allow-forms allow-scripts allow-popups allow-same-origin"), t.width = e.width.toString(), t.height = e.height.toString(), t.style.border = "none", t.referrerPolicy = "origin", t;
  }
  onMessage(i) {
    var t, o, d, s, h, c, g, l, p, m, f, _;
    if (i.origin !== this.pageOrigin)
      return;
    const e = i.data;
    e.type === "payment_complete" ? (o = (t = this.callbacks).payment_complete) == null || o.call(t, e.payload) : e.type === "3ds_redirect" ? (s = (d = this.callbacks)["3ds_redirect"]) == null || s.call(d) : e.type === "submit_available_changed" ? (c = (h = this.callbacks).submit_available_changed) == null || c.call(h, e.payload) : e.type === "form_layout_changed" ? (l = (g = this.callbacks).form_layout_changed) == null || l.call(g, e.payload) : e.type === "cardholder_required_changed" ? (m = (p = this.callbacks).cardholder_required_changed) == null || m.call(p, e.payload) : e.type === "payment_begin" && ((_ = (f = this.callbacks).payment_begin) == null || _.call(f));
  }
};
r(a, "pageOrigin", "https://payment.bog.ge"), r(a, "devPageOrigin", "https://payment-test.bog.ge"), r(a, "pagePathname", "/iframe");
let y = a;
export {
  y as BogPaymentSession
};
//# sourceMappingURL=bog-payments-web-sdk.js.map
